<script>
  import debounce from 'lodash-es/debounce'
  import { format } from 'date-fns/format'
  import { add } from 'date-fns/add'

  import { PLAN_LIST, PLAN_MAP } from './constants/plan'
  import { COURSE_LIST } from './constants/course'
  import { DEBOUNCED_MS } from './constants/validation'

  import DatePicker from 'saison-date-picker'
  import { createInputValidator, requiredValidator, numberValidator, convertNumber } from 'saison-input-validator'

  import { simulate } from './functions/simulate'

  const getTestModeValue = () => {
    const search = location.search.slice(1)
    const params = new URLSearchParams(search)
    const testMode = params.get('testMode')
    return parseInt(testMode, 10)
  }
  const isTestMode = getTestModeValue() === 1

  const [planValidity, planValidate] = createInputValidator(requiredValidator())

  const [courseValidity, courseValidate] = createInputValidator(courseValidator())

  const [moneyValidity, moneyValidate] = createInputValidator(
    requiredValidator(),
    numberValidator({
      min: 1,
      max: 90,
    })
  )

  const [rateValidity, rateValidate] = createInputValidator(
    requiredValidator(),
    numberValidator({
      min: 12,
      max: 18,
      decimalPlaces: 2,
    })
  )

  const today = isTestMode ? '' : format(new Date(), 'yyyy-MM-dd')
  const threeMonthsLaterDate = format(add(new Date(), { months: 3 }), 'yyyy-MM-dd')
  const threeMonthsLater = isTestMode ? '' : threeMonthsLaterDate

  let datePicker

  let targetDate
  let amountMoney5Digit
  let ratePerYear
  let planCode
  let courseCode

  let display = {
    targetDate: null,
    amountMoney5Digit: '',
    ratePerYear: '',
    planCode: '',
    courseCode: '',
  }

  let everyPaymentDate = []
  let everyCommissions = []
  let everyPayments = []

  let numOfPayments
  let totalPayment
  let totalCommission

  let isTargetDateDirty = false
  let isTargetDateValid = false

  const debouncedDirtyTargetDate = debounce(function () {
    isTargetDateDirty = true
  }, DEBOUNCED_MS)
  function handleBlurTargetDate(event) {
    debouncedDirtyTargetDate()
    isTargetDateValid = event.detail.isValid
  }

  function courseValidator() {
    return function plan(value) {
      if (planCode === PLAN_MAP.BULLET.code) {
        return true
      }
      const isValid = value !== undefined && value !== null && value !== ''
      return isValid ? true : '必須項目です'
    }
  }

  function estimate() {
    const isRevo = planCode === PLAN_MAP.FLAT_RATE_REVOLVING.code

    // 一度フォーカスさせないとエラーのツールチップが出ないのでフォーカスさせている
    document.getElementById('txtRate').focus()
    document.getElementById('txtRate').blur()
    document.getElementById('txtLoan').focus()
    document.getElementById('txtLoan').blur()
    document.getElementById('plan').focus()
    document.getElementById('plan').blur()
    if(isRevo) {
      // リボを選んでいない時は非表示になっているのでスキップ
      document.getElementById('course').focus()
      document.getElementById('course').blur()
    }
    document.getElementById('targetDate').focus()
    document.getElementById('targetDate').blur()

    // 最後にボタンにフォーカスを戻す
    this.focus()

    if (
      !$moneyValidity.valid ||
      !$rateValidity.valid ||
      !$planValidity.valid ||
      (isRevo && !$courseValidity.valid) || // リボを選んでいない時は不要
      !isTargetDateValid
    ) {
      return
    }

    const result = simulate(targetDate, amountMoney5Digit * 10000, ratePerYear, planCode, courseCode)
    everyPaymentDate = result.everyPaymentDate
    everyCommissions = result.everyCommissions
    everyPayments = result.everyPayments

    //入力内容表示
    display = {
      targetDate,
      amountMoney5Digit: amountMoney5Digit * 1,
      ratePerYear: ratePerYear * 1,
      planCode,
      courseCode,
    }

    //支払回数
    numOfPayments = everyPayments.length
    //支払総額
    totalPayment = everyPayments.reduce((total, payment) => {
      return total + payment
    }, 0)
    //手数料合計
    totalCommission = everyCommissions.reduce((total, commission) => {
      return total + commission
    }, 0)

    setTimeout(() => {
      // setTimeoutが無いと、ブラウザによっては先頭にスクロールできない
      document.documentElement.scrollTop = 0
    }, 100)
  }

  function clear() {
    targetDate = null
    amountMoney5Digit = ''
    ratePerYear = ''
    planCode = ''
    courseCode = ''

    datePicker.clear()
  }

  function onScrollTable(event){
    const { target } = event
    if (target.scrollLeft > 10) {
      target.classList.add('-hide')
    } else {
      target.classList.remove('-hide')
    }
  }
</script>

<div class="sc21-u-sectionWhite">
  {#if everyPayments.length > 0}
    <div class="sc21-u-subSection">
      <section>
        <div class="sc21-TBL-vertical">
          <h2 class="sc21-TBL-vertical__caption">ご入力いただいた条件</h2>
          <dl class="sc21-TBL-vertical__table -columns-1:1">
            <dt class="sc21-TBL-vertical__heading">ご利用希望金額</dt>
            <dd class="sc21-TBL-vertical__cell bold">{display.amountMoney5Digit}0,000円</dd>
            <dt class="sc21-TBL-vertical__heading">ご融資利率（実質年率）</dt>
            <dd class="sc21-TBL-vertical__cell bold">{display.ratePerYear}％</dd>
            <dt class="sc21-TBL-vertical__heading">ご返済方式</dt>
            <dd class="sc21-TBL-vertical__cell bold">{PLAN_LIST.find(plan => plan.code === display.planCode).label}</dd>
            <dt class="sc21-TBL-vertical__heading">お支払コース</dt>
            <dd class="sc21-TBL-vertical__cell bold">
              {#if display.planCode !== PLAN_MAP.BULLET.code && display.courseCode !== ''}
                {COURSE_LIST.find(course => course.code === display.courseCode).label}
              {/if}
            </dd>
            <dt class="sc21-TBL-vertical__heading">ご利用予定日</dt>
            <dd class="sc21-TBL-vertical__cell bold">{format(display.targetDate, 'yyyy年M月d日')}</dd>
          </dl>
        </div>

        <div class="sc21-TBL-vertical">
          <h2 class="sc21-TBL-vertical__caption">ご返済シミュレーション詳細</h2>
          <dl class="sc21-TBL-vertical__table -columns-1:1">
            <dt class="sc21-TBL-vertical__heading">お支払回数</dt>
            <dd class="sc21-TBL-vertical__cell">{numOfPayments}回</dd>
            <dt class="sc21-TBL-vertical__heading">初回のお支払日</dt>
            <dd class="sc21-TBL-vertical__cell">{format(everyPaymentDate[0], 'yyyy年M月d日')}</dd>
            <dt class="sc21-TBL-vertical__heading">初回のお支払金額</dt>
            <dd class="sc21-TBL-vertical__cell">{everyPayments[0].toLocaleString('ja-JP')}円</dd>
            <dt class="sc21-TBL-vertical__heading">最終回のお支払日</dt>
            <dd class="sc21-TBL-vertical__cell">
              {format(everyPaymentDate[everyPaymentDate.length - 1], 'yyyy年M月d日')}
            </dd>
            <dt class="sc21-TBL-vertical__heading">最終回のお支払金額</dt>
            <dd class="sc21-TBL-vertical__cell">{everyPayments[everyPayments.length - 1].toLocaleString('ja-JP')}円</dd>
          </dl>
        </div>

        <div class="sc21-TBL-vertical">
          <h2 class="sc21-TBL-vertical__caption">ご返済お支払い総額</h2>
          <dl class="sc21-TBL-vertical__table -columns-1:1">
            <dt class="sc21-TBL-vertical__heading">お支払総額</dt>
            <dd class="sc21-TBL-vertical__cell">{totalPayment.toLocaleString('ja-JP')}円</dd>
            <dt class="sc21-TBL-vertical__heading">うちお利息合計</dt>
            <dd class="sc21-TBL-vertical__cell">{totalCommission.toLocaleString('ja-JP')}円</dd>
          </dl>
        </div>

        <div class="sc21-TBL-scroll">
          <h2 class="sc21-TBL-scroll__caption">各回のお支払金額詳細</h2>
          <div class="sc21-TBL-scroll__scrollable">
            <div class="sc21-TBL-scroll__inner -force" on:scroll={onScrollTable}>
              <div class="sc21-TBL-scroll__content">
                <table>
                  <thead>
                    <tr class="bgGray">
                      <th class="center regular w20" scope="row">お支払回数</th>
                      <th class="center regular" scope="row">支払月</th>
                      <th class="center regular" scope="row">お支払金額</th>
                      <th class="center regular" scope="row">うちお利息</th>
                    </tr>
                  </thead>
                  <tbody>
                    {#each everyPayments as payment, index}
                      <tr>
                        <th class="center regular bgGray" scope="col">{index + 1}</th>
                        <td class="center">{format(everyPaymentDate[index], 'yyyy年M月')}</td>
                        <td class="right">{payment.toLocaleString('ja-JP')}円</td>
                        <td class="right">{everyCommissions[index].toLocaleString('ja-JP')}円</td>
                      </tr>
                    {/each}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <hr class="sc21-BDR-1 sc21-u-mt-0" />
  {/if}

  {#if everyPayments.length > 0}
    <h2 class="sc21-HLN-2">再度シミュレーションする</h2>
  {:else}
    <p class="sc21-TXT-normal">以下の条件を入力して「試算する」ボタンを押してください。</p>
  {/if}
  <div class="sc21-CreditCardSimulateForm">
    <p class="sc21-CreditCardSimulateForm-note sc21-TXT-red">*は必須の入力項目となります。</p>
    <div class="sc21-CreditCardSimulateForm-form sc21-FRM">
      <dl class="sc21-FRM__content">
        <dt class="sc21-FRM__heading">
          <label for="txtLoan" class="sc21-FRM__label">ご利用金額（万円） <em>*</em></label>
        </dt>
        <dd class="sc21-FRM__body">
          <div class="sc21-FRM__action">
            <input
              type="text"
              name="txtLoan"
              id="txtLoan"
              size="4"
              maxlength="2"
              autocomplete="off"
              class="sc21-FRM__textInput-small"
              required
              aria-invalid="{$moneyValidity.dirty && !$moneyValidity.valid}"
              aria-describedby="error_amount"
              bind:value="{amountMoney5Digit}"
              class:field-danger="{!$moneyValidity.valid}"
              class:field-success="{$moneyValidity.valid}"
              use:moneyValidate="{amountMoney5Digit}"
              on:input="{e => (amountMoney5Digit = convertNumber(e.target.value, e.target.attributes.maxlength.value))}"
            />
            万円
            {#if $moneyValidity.dirty && !$moneyValidity.valid}
              <p id="error_amount" class="sc21-FRM__errorTooltip" role="alert">{$moneyValidity.message}</p>
            {/if}
          </div>
          <div class="sc21-LST-annotation">
            <ul>
              <li>1万円～90万円までの、ご利用可能枠の範囲で入力してください。</li>
            </ul>
          </div>
        </dd>
        <dt class="sc21-FRM__heading">
          <label for="txtRate" class="sc21-FRM__label">ご融資利率（実質年率） <em>*</em></label>
        </dt>
        <dd class="sc21-FRM__body">
          <div class="sc21-FRM__action">
            <input
              type="text"
              name="txtRate"
              id="txtRate"
              size="5"
              maxlength="5"
              autocomplete="off"
              class="sc21-FRM__textInput-small"
              required
              aria-invalid="{$rateValidity.dirty && !$rateValidity.valid}"
              aria-describedby="error_txtRate"
              bind:value="{ratePerYear}"
              class:field-danger="{!$rateValidity.valid}"
              class:field-success="{$rateValidity.valid}"
              use:rateValidate="{ratePerYear}"
              on:input="{e => (ratePerYear = convertNumber(e.target.value, e.target.attributes.maxlength.value))}"
            />
            ％
            {#if $rateValidity.dirty && !$rateValidity.valid}
              <p id="error_txtRate" class="sc21-FRM__errorTooltip" role="alert">{$rateValidity.message}</p>
            {/if}
          </div>
          <div class="sc21-LST-annotation">
            <ul>
              <li>12.00％～18.00％以下で入力してください。（小数点第2位まで入力可能）</li>
            </ul>
          </div>
        </dd>
        <dt class="sc21-FRM__heading"><label for="plan" class="sc21-FRM__label">ご返済方式 <em>*</em></label></dt>
        <dd class="sc21-FRM__body">
          <div class="sc21-FRM__action">
            <select
              id="plan"
              required
              class="sc21-FRM__selectbox"
              aria-invalid="{$planValidity.dirty && !$planValidity.valid}"
              aria-describedby="error_plan"
              bind:value="{planCode}"
              class:field-danger="{!$planValidity.valid}"
              class:field-success="{$planValidity.valid}"
              use:planValidate="{planCode}"
            >
              <option value="" selected>項目を選択してください</option>
              {#each PLAN_LIST as plan}
                <option value="{plan.code}">{plan.label}</option>
              {/each}
            </select>
            {#if $planValidity.dirty && !$planValidity.valid}
              <p id="error_plan" class="sc21-FRM__errorTooltip" role="alert">{$planValidity.message}</p>
            {/if}
          </div>
        </dd>
        <dt class="sc21-FRM__heading" class:sc21-FRM__heading-hidden={planCode !== PLAN_MAP.FLAT_RATE_REVOLVING.code}><label for="course" class="sc21-FRM__label">お支払コース</label></dt>
        <dd class="sc21-FRM__body" class:sc21-FRM__body-hidden={planCode !== PLAN_MAP.FLAT_RATE_REVOLVING.code}>
          <div class="sc21-FRM__action">
            <select
              id="course"
              required
              class="sc21-FRM__selectbox"
              aria-invalid="{$courseValidity.dirty && !$courseValidity.valid}"
              aria-describedby="error_course"
              bind:value="{courseCode}"
              class:field-danger="{!$courseValidity.valid}"
              class:field-success="{$courseValidity.valid}"
              use:courseValidate="{courseCode}"
            >
              <option value="" selected>項目を選択してください</option>
              {#each COURSE_LIST as course}
                <option value="{course.code}">{course.label}</option>
              {/each}
            </select>
            {#if $courseValidity.dirty && !$courseValidity.valid}
              <p id="error_course" class="sc21-FRM__errorTooltip" role="alert">{$courseValidity.message}</p>
            {/if}
          </div>
          <div class="sc21-LST-annotation">
            <ul>
              <li>ご返済方式が「一括返済方式」の場合入力不要です。</li>
            </ul>
          </div>
          <ul class="sc21-LNK-txt sc21-u-mt-0">
            <li class="sc21-LNK-txt__item">
              <a href="/guide/gu003.html#sec03" class="sc21-LNK-txt__link">
                <svg width="14" height="14" class="sc21-LNK-txt__arrow">
                  <use href="#sc21-arrowRightCircle"></use>
                </svg>
                <span>お支払コースごとの月々のお支払額</span>
              </a>
            </li>
          </ul>
        </dd>

        <dt class="sc21-FRM__heading"><label for="targetDate" class="sc21-FRM__label">ご利用日 <em>*</em></label></dt>
        <dd class="sc21-FRM__body">
          <div class="sc21-FRM__action">
            <DatePicker
              id="targetDate"
              min="{today}"
              max="{threeMonthsLater}"
              required="{true}"
              bind:value="{targetDate}"
              bind:this="{datePicker}"
              on:blur="{handleBlurTargetDate}"
              on:change="{handleBlurTargetDate}"
            />
            {#if isTargetDateDirty && !isTargetDateValid}
              <p id="error_targetDate" class="sc21-FRM__errorTooltip" role="alert">
                本日から3ヵ月以内の日付を入力してください
              </p>
            {/if}
          </div>
          <div class="sc21-LST-annotation">
            <ul>
              <li>本日から3ヵ月以内で入力してください。</li>
            </ul>
          </div>
        </dd>
      </dl>

      <div class="sc21-CreditCardSimulateForm-submit">
        <button on:click="{estimate}" class="sc21-BTN-normal">
          <span>試算する</span>
          <svg width="7" height="11">
            <use href="#sc21-arrowRight"></use>
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
